import { BenefitLayout } from "providers/benefit-layout";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import { Button, ButtonVariant } from "shared/components/Button";
import { FC } from "react";

type Props = {
  title: string;
  subtext1?: string;
  subtext2?: string;
  buttonTitle: string;
  onButtonClick: () => void;
};

export const SuccessScreenView: FC<Props> = ({
  title,
  subtext1,
  subtext2,
  buttonTitle,
  onButtonClick
}) => {
  return (
    <BenefitLayout
      title=""
      footer={
        <div>
          <Button
            className="w-full max-w-[440px] mx-auto"
            variant={ButtonVariant.PRIMARY}
            onClick={onButtonClick}
          >
            {buttonTitle}
          </Button>
        </div>
      }
    >
      <div className="pb-6 max-w-[440px] w-full mx-auto">
        <SuccessIcon width={40} height={40} className="mb-6 text-success-500" />
        <h1 className="text-content-1000 text-xl font-bold mb-6">{title}</h1>
        <p className="text-content-500 text-sm mb-6">{subtext1}</p>
        {subtext2 ? (
          <p className="text-content-500 text-sm">{subtext2}</p>
        ) : null}
      </div>
    </BenefitLayout>
  );
};
